'use client';

import { useState, useEffect, useRef } from 'react';
import Image from 'next/image';

const WorkshopStats = () => {
  // Using just the image links from the provided list
const [mentorImages, setMentorImages] = useState([
  "https://d3kl8zsmmx4oop.cloudfront.net/Akhilesh_Agrawal_2023_10_04_profile_Photo_1ea5aea859.jpeg",
  "https://d3kl8zsmmx4oop.cloudfront.net/Harsit_Pareek_2024_02_21_profile_Photo_0efd4c0038.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/DSCF_2314_2_7370d856e7.jpg",
  "https://d3kl8zsmmx4oop.cloudfront.net/um8_ea7bb59841.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/27883_79bc5e75_d1dd_4215_bb69_ca64df51810f_c80102a777.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/IMG_3594_removebg_preview_d65dc34923.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/um3_6fbf2cd54d.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/um1_37d3c4c52a.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/6471d10ea313b6e7525ef580_Frame_1430103582_1976fa7d6a.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/1517590107823_86c57e89cd.jpeg",
  "https://d3kl8zsmmx4oop.cloudfront.net/Raghuveer_Nishtala_2023_08_07_profile_Photo_93f91717db.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/um12_e825193b56.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/um13_84a043538c.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/um24_375232dfb6.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/um35_de646040bf.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/Amit_Dubey_2023_10_04_profile_Photo_ff2b1629b7.jpeg",
  "https://d3kl8zsmmx4oop.cloudfront.net/Whats_App_Image_2022_06_01_at_4_16_01_PM_2_removebg_preview_e1bd999955.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/Arman_Sood_2024_02_23_banner_Photo_f943609f05.jpg",
  "https://d3kl8zsmmx4oop.cloudfront.net/Sarvistha_8369e67726.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/Frederick_Vallaeys_25f84e2f3f.jpg",
  "https://d3kl8zsmmx4oop.cloudfront.net/62d0061fcd5cb471a25f585e_unsplash_r_DEO_Vt_E7v_Os_1_712a36c567.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/1671726835801_f178826426.jpeg",
  "https://d3kl8zsmmx4oop.cloudfront.net/um4_0a8c293a82.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/um18_a698ade6d7.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/um30_410943f2a7.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/um34_d5773c5343.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/um37_d978a3916c.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/um38_e48c21a238.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/Dear_Founder_CXO_Check_your_inbox_for_Get_Yourself_The_Coolest_promotion_1_54860b6cd7.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/Apoorva_Singh_2024_01_05_profile_Photo_cf2e1c63ee.JPG",
  "https://d3kl8zsmmx4oop.cloudfront.net/saptarshi_prakash_1199491e35.jpeg",
  "https://d3kl8zsmmx4oop.cloudfront.net/v_2dffcb8ecc.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/Ria_Mirchandani_2023_10_04_profile_Photo_661a13b41c.jpeg",
  "https://d3kl8zsmmx4oop.cloudfront.net/1585544756879_88de006bcf.jpeg",
  "https://d3kl8zsmmx4oop.cloudfront.net/pratik_68d514720e.jpeg",
  "https://d3kl8zsmmx4oop.cloudfront.net/Whats_App_Image_2023_03_05_at_1_17_32_PM_5f580fc905.jpeg",
  "https://d3kl8zsmmx4oop.cloudfront.net/um33_8aec339e1f.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/Sanjeet_Shankar_Srivastava_2024_04_16_profile_Photo_7b51f47c5e.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/vvvvvvvvvvv_35b518464c.jpeg",
  "https://d3kl8zsmmx4oop.cloudfront.net/um17_94b0683d2b.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/um23_43c63f5288.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/Diksha_Aggarwal_2023_08_08_profile_Photo_c7811eebf9.jpeg",
  "https://d3kl8zsmmx4oop.cloudfront.net/Rizurekh_Saha_2023_08_19_profile_Photo_31fd44eb20.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/Kanan_Rai_2023_08_19_profile_Photo_335d7e6c3e.jpeg",
  "https://d3kl8zsmmx4oop.cloudfront.net/um2_a26b2b8ef4.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/Dear_Founder_CXO_Check_your_inbox_for_Get_Yourself_The_Coolest_promotion_e9d25e6d56.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/Screenshot_2022_08_11_at_1_48_32_PM_removebg_preview_6811bca698.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/Untitled_design_5994125071.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/62b5867be39d8f318214d071_DSC_02071_1_p_800_03d4d1de13.jpeg",
  "https://d3kl8zsmmx4oop.cloudfront.net/Naggappan_Ramasamy_2023_08_19_profile_Photo_9c00e5bd79.jpeg",
  "https://d3kl8zsmmx4oop.cloudfront.net/Siddhant_Lodha_2023_07_03_profile_Photo_4aeeffea8a.jpeg",
  "https://d3kl8zsmmx4oop.cloudfront.net/Mayank_Nagpal_2023_08_30_profile_Photo_160ead51ef.jpeg",
  "https://d3kl8zsmmx4oop.cloudfront.net/Ajeet_Khurana_2023_08_30_profile_Photo_9195e33b2e.jpeg",
  "https://d3kl8zsmmx4oop.cloudfront.net/Vedant_Rusty_2023_08_30_profile_Photo_e82a6f005c.jpeg",
  "https://d3kl8zsmmx4oop.cloudfront.net/Pradnya_Sinha_2023_09_20_banner_Photo_bffde124a7.jpeg",
  "https://d3kl8zsmmx4oop.cloudfront.net/Ishan_Singh_2023_09_22_profile_Photo_958a6db959.jpg",
  "https://d3kl8zsmmx4oop.cloudfront.net/Sudeep_Chawla_2023_10_04_profile_Photo_c6f2471e18.jpeg",
  "https://d3kl8zsmmx4oop.cloudfront.net/Vedanarayanan_Vedantham_2023_10_04_profile_Photo_a7ce179e8a.jpeg",
  "https://d3kl8zsmmx4oop.cloudfront.net/Sreejith_Govind_2023_10_04_profile_Photo_91dc147d50.jpeg",
  "https://d3kl8zsmmx4oop.cloudfront.net/CA_Varun_Singhania_2023_10_04_profile_Photo_46c5b4c210.jpeg",
  "https://d3kl8zsmmx4oop.cloudfront.net/um15_cc478c0670.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/Varun_Khullar_2023_10_11_banner_Photo_3c3239f3c4.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/Shantam_Khetan_2023_10_25_profile_Photo_d93a1d4314.png",
  "https://d3kl8zsmmx4oop.cloudfront.net/Deeksha_Anand_2023_07_14_profile_Photo_dc3d8aa297.jpeg",
  "https://d3kl8zsmmx4oop.cloudfront.net/Anuttam_Grandhi_2024_01_02_profile_Photo_f3c9521919.jpeg",
  "https://d3kl8zsmmx4oop.cloudfront.net/um7_8ff0450938.png",
]);

  // Clone the mentors for infinite scroll effect, repeat 3 times for better continuous effect
  const extendedMentorImages = [...mentorImages, ...mentorImages, ...mentorImages];
  
  // Ref for the marquee container
  const marqueeRef = useRef(null);

  return (
    <section className=" bg-white">
      <div className="w-[90%] md:w-[80%] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 ">
          {/* First Card - Left Column */}
          <div className="bg-white rounded-3xl border h-[350px] border-[hsla(176,8%,62%,0.4)] overflow-hidden flex flex-col">
            <div className="p-6 flex-grow">
              <h2 className="text-[#002726] text-2xl font-medium mb-2">
                This is a certified workshop
              </h2>
              <p className="text-[#002726] text-sm uppercase tracking-wider font-medium">
                BECOME A CERTIFIED EXPERT
              </p>
            </div>
            <div className="w-full h-40 relative mt-auto">
              <Image
                src="https://d31bwppm8yl9g2.cloudfront.net/learner/website/wcer.svg"
                alt="Certificate"
                fill
                className="object-contain"
                unoptimized={true}
              />
            </div>
          </div>

          {/* Middle Column - Two Cards */}
          <div className="flex flex-col gap-6">
            {/* Top Card - 400k+ learners - MAKE IMAGE BIGGER */}
            <div className="bg-white rounded-3xl h-[160px] border border-[hsla(176,8%,62%,0.4)] overflow-hidden flex-grow flex flex-col relative">
              {/* Text Content */}
              <div className="p-6 flex-grow z-10">
                <h2 className="text-[#002726] text-3xl font-medium mb-2">
                  400k+ learners
                </h2>
                <p className="text-[#002726] text-sm uppercase tracking-wider font-medium">
                  HAVE BENEFITTED
                </p>
              </div>
              
              {/* Image - Now positioned absolutely to take more space but not overflow content */}
              <div className="absolute right-0 bottom-0 w-2/3 h-full">
                <Image
                  src="https://d31bwppm8yl9g2.cloudfront.net/learner/website/wpeop.svg"
                  alt="Learners"
                  fill
                  className="object-contain object-right-bottom"
                  unoptimized={true}
                />
              </div>
            </div>

            {/* Bottom Card - Learn insider hacks - MAKE IMAGE BIGGER */}
            <div className="bg-white rounded-3xl h-[160px] border border-[hsla(176,8%,62%,0.4)] overflow-hidden flex-grow flex flex-col relative">
              {/* Text Content */}
              <div className="p-6 flex-grow z-10">
                <h2 className="text-[#002726] text-2xl font-medium mb-2">
                  Learn insider hacks
                </h2>
                <p className="text-[#002726] text-sm uppercase tracking-wider font-medium">
                  HELP BOOST YOUR PRODUCTIVITY
                </p>
              </div>
              
              {/* Image - Now positioned absolutely to take more space but not overflow content */}
              <div className="absolute right-0 bottom-0 w-1/3 h-full">
                <Image
                  src="https://d31bwppm8yl9g2.cloudfront.net/learner/website/wthr.svg"
                  alt="Insider Hacks"
                  fill
                  className="object-contain object-right-bottom"
                  unoptimized={true}
                />
              </div>
            </div>
          </div>

          {/* Right Column - Mentor Carousel */}
          <div className="bg-white rounded-3xl border border-[hsla(176,8%,62%,0.4)] overflow-hidden flex flex-col">
            <div className="p-6">
              <h2 className="text-[#002726] text-2xl font-medium mb-2">
                Learn only from top mentors
              </h2>
              <p className="text-[#002726] text-sm uppercase tracking-wider font-medium">
                HERE TO HELP YOU THROUGH EVERY STEP
              </p>
            </div>
            
            {/* Image Marquee */}
            <div className="px-6 flex-grow overflow-hidden">
              <div className="flex gap-3 marquee-container">
                <div
                  className="flex gap-3 animate-marquee"
                  style={{
                    animationDuration: '60s',
                    animationIterationCount: 'infinite',
                    animationTimingFunction: 'linear'
                  }}
                >
                  {extendedMentorImages.map((imageUrl, index) => (
                    <div key={index} className="flex-shrink-0">
                      <div className="rounded-lg overflow-hidden border border-gray-200 mb-2">
                        <div className="relative w-32 h-32">
                          <Image
                            src={imageUrl}
                            alt={`Mentor ${index + 1}`}
                            fill
                            className="object-cover"
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add CSS for animation */}
      <style jsx global>{`
        @keyframes marquee {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-33.33%); /* Move by 1/3 since we tripled the images */
          }
        }
        
        .animate-marquee {
          animation-name: marquee;
          animation-timing-function: linear;
          animation-iteration-count: infinite;
        }
        
        .marquee-container {
          overflow: hidden;
          width: 100%;
        }
      `}</style>
    </section>
  );
};

export default WorkshopStats;